// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';

import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { CompassCrossFlowTouchPoint } from '@atlassian/jira-compass-cross-flow';
import { CrossFlowProvider } from '@atlassian/jira-cross-flow';

type Props = {
	isCompassLicensed: boolean;
	origin: string;
	onCrossFlowComplete?: () => void;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CrossFlowTouchPointWrapper = styled.div({
	margin: `${token('space.200', '16px')} 0 ${token('space.200', '16px')} 0`,
});

// eslint-disable-next-line jira/react/no-class-components
class CompassCrossFlow extends PureComponent<Props> {
	static defaultProps: Partial<Props> = {
		isCompassLicensed: false,
	};

	render() {
		const { isCompassLicensed, origin, onCrossFlowComplete } = this.props;

		return (
			!isCompassLicensed && (
				<CrossFlowProvider>
					<CrossFlowTouchPointWrapper>
						<CompassCrossFlowTouchPoint
							origin={origin}
							eventSource="jiraComponentsSection"
							onCrossFlowComplete={onCrossFlowComplete}
						/>
					</CrossFlowTouchPointWrapper>
				</CrossFlowProvider>
			)
		);
	}
}

export default CompassCrossFlow;
